'use strict';

module.exports = FormData;



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/browser/classes/FormData.js
// module id = 687
// module chunks = 0